// cSpell:ignore tila
import axios, { AxiosError } from 'axios'
import config from 'config'
import { ReturnCustomerSelectionsType } from 'containers/ReturnCustomer/types/returnCustomerTypes'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'
import {
    SelectedExtendedWarranty,
    SelectedExtendedServiceContracts,
    SelectedTireAndWheel,
} from './interfaces/ClientApplication'
import { SubmitApplicationDTO } from './postApplication'

export interface UpdateClientApplication {
    home_phone?: string
    mobile_phone?: string
    residential_status?: string
    residential_years?: string
    residential_months?: string
    monthly_housing_payment?: string
    job_title?: string
    employment_status?: string
    employer_name?: string
    employer_years?: string
    employer_months?: string
    employer_monthly_gross?: string
    email_address?: string

    application_type?: string
    return_customer?: ReturnCustomerSelectionsType
    type?: string // Loan or Lease

    coapplicant_home_phone?: string
    coapplicant_mobile_phone?: string
    coapplicant_residential_status?: string
    coapplicant_residential_years?: string
    coapplicant_residential_months?: string
    coapplicant_monthly_housing_payment?: string
    coapplicant_job_title?: string
    coapplicant_employment_status?: string
    coapplicant_employer_name?: string
    coapplicant_employer_years?: string
    coapplicant_employer_months?: string
    coapplicant_employer_monthly_gross?: string
    coapplicant_email_address?: string

    customer_down_payment?: string
    customer_down_payment_override?: string
    financed_sales_tax?: number
    dealer_document_service_charge?: number
    dealer_title?: number
    dealer_freight?: number
    setup_charge?: number
    parts_and_labor?: number
    oem_accessories?: number
    other_goods_and_accessories?: number
    other?: number
    oem_rebate?: number
    pre_paid_maintenance?: number
    tire_and_wheel?: number
    extended_service_plan?: number
    gap_insurance?: number
    windshield_coverage?: number
    paintless_dent_repair?: number
    vehicle_appearance_products?: number
    etch_anti_theft?: number
    key_fob_protection_plan?: number
    other_backend?: number
    trailer_sales_price?: number
    trade_in_allowance?: number
    trade_in_payoff?: number
    trade_in_type?: string | null
    vehicle_asking_price?: number
    documentary_stamp_tax_amount?: number

    selected_tire_and_wheel?: SelectedTireAndWheel | null
    selected_extended_warranty?: SelectedExtendedWarranty | null
    selected_extended_service_contracts?: SelectedExtendedServiceContracts | null
    // Per-collateral ESC selections for the B.E.S.T. multi-collateral flow.
    // Minimal contract; backend acceptance to be confirmed.
    selected_extended_service_contracts_by_collateral?:
        | {
              collateral_id: number
              warranty_product_price_id: number
              customer_price: number
          }[]
        | null
    pre_paid_maintenance_selection_enabled?: boolean
    selected_approval_term_id?: number | null
    adjusted_monthly_payment?: number
    extended_warranty_selection_enabled?: boolean
    tire_and_wheel_selection_enabled?: boolean
    wtd_tila_apr?: number | null
    wtd_customer_fee?: number

    deal_owner?: {
        owner_name: string
        user_id: number | null
    }
}

export default async function patchApplication(
    params: UpdateClientApplication | SubmitApplicationDTO,
    uuid: string,
    abortController?: AbortController,
) {
    try {
        const response = await axios.patch(
            `${config.API_BASE_URL}/api/v3/client-application/${uuid}/`,
            params,
            {
                signal: abortController?.signal,
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
            },
        )

        return response.data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to update application: ${axiosError.message}`,
            axiosError,
            { application: { uuid } },
        )

        throw error
    }
}
